// extracted by mini-css-extract-plugin
export default {"compactModeCheckbox":"compactModeCheckbox_JE3YH","InputArea":"InputArea_ZQprq"};